import Vue from 'vue'
import VueRouter from 'vue-router'
import SubscriptionPaymentView from '@/views/SubscriptionPaymentView.vue'
import AddonActivationPayment from "@/components/AddonActivationPayment.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'subscription-payment',
        component: SubscriptionPaymentView,
    },
    {
        path: '/addon-activation',
        name: "addon-activation",
        component: AddonActivationPayment,
    },
    // Redirect old route name for backwards compatibility
    {
        path: '/home',
        redirect: { name: 'subscription-payment' }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})
export default router
